import React from "react";
import { Link } from "react-router-dom";
import { formatInrFromPaise } from "../utils/validation";

export default function PlanCard({ plan, highlighted }) {
  return (
    <article className={`saas-plan-card${highlighted ? " saas-plan-card--highlight" : ""}`}>
      <h3>{plan.name}</h3>
      <p className="saas-plan-card__desc">{plan.description}</p>
      <p className="saas-plan-card__price">
        {formatInrFromPaise(plan.monthly_price_paise)}
        <span>/mo</span>
      </p>
      <p className="saas-plan-card__yearly">or {formatInrFromPaise(plan.yearly_price_paise)}/year</p>
      <ul>
        {plan.user_limit ? <li>Up to {plan.user_limit} users</li> : null}
        {plan.storage_limit_mb ? <li>{Math.round(plan.storage_limit_mb / 1024)} GB storage</li> : null}
        {plan.trial_eligible ? <li>{plan.trial_days}-day free trial</li> : null}
      </ul>
      {plan.trial_eligible ? (
        <Link to={`/signup?plan=${plan.slug}`} className="saas-btn saas-btn--primary">
          Start Free Trial
        </Link>
      ) : (
        <a href="mailto:sales@beentara.com" className="saas-btn saas-btn--secondary">
          Contact Sales
        </a>
      )}
    </article>
  );
}
